import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
//Import Custom Services Here
import { SchoolService } from "../../../shared/services/school.service";
import { NumCardsService } from "../report-services/num-cards.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	templateUrl: "./numberofcardsprinted.component.html",
})
export class NumberofCardsPrintedComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private numcardsService: NumCardsService,
		private schoolService: SchoolService,
		private dialogService: DialogService
	) {}
	report = {
		//Insert Custom Parameters Here
		SchoolID: 0,
		NumCardsID: 0,
		STARTDATE: new Date(),
		ENDDATE: new Date(),
		ORDERBYID: "Grade",
		ImageLogo: "",
	};

	//Insert Custom Lists Here
	schoolList: any = [];
	NumCardsList: any = [];
	ImageLogoList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 153;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ORDERBYList = [
		//Insert Custom List Items Here
		{
			ORDERBYID: "Grade",
			ORDERBYName: "Grade",
		},
		{
			ORDERBYID: "Homeroom",
			ORDERBYName: "Homeroom",
		},
		{
			ORDERBYID: "Name",
			ORDERBYName: "Name",
		},
		{
			ORDERBYID: "Number Printed",
			ORDERBYName: "Number Printed",
		},
	];

	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadSchoolist()
		this.loadNumCardsList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		//this.loadNumCardsList()
		this.loadLogolist();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(153);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
					this.report.SchoolID = this.schoolList[0].SchoolID;
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadNumCardsList() {
		this.report.NumCardsID = 0;

		this.NumCardsList = [];

		for (var i = 0; i <= 100; i++) {
			let nextEntry = {
				ID: i,
				Description: i.toString(),
			};
			this.NumCardsList.push(nextEntry);
		}

		// this.report.NumCardsID = 0;
		// var result = this.numcardsService.loadNumCardsList(0, this.report.SchoolID);
		// result.subscribe(
		//     response => {
		//         this.NumCardsList = response;

		//         if (this.NumCardsList.length > 1) {
		//             this.NumCardsList.unshift({
		//                 NumCardsID: 0,
		//                 NumCardsDesc: "All NumCardss"
		//             })
		//         } else {
		//             this.report.NumCardsID = this.NumCardsList[0].NumCardsID
		//         }

		//     },
		//     error => {
		//     }
		// )
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		// if (!this.report.NumCardsID) {
		// 	this.errorMessage = "Select the NumCards"
		// 	return;
		// }

		// if (!this.report.STARTDATE) {
		// 	this.errorMessage = "Select the STARTDATE"
		// 	return;
		// }

		// if (!this.report.ENDDATE) {
		// 	this.errorMessage = "Select the ENDDATE"
		// 	return;
		// }

		// if (!this.report.ORDERBYID) {
		// 	this.errorMessage = "Select the ORDERBY"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 153;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolID
		strParam += this.report.SchoolID + "|SchoolID";

		//Parameter 2: NumCards
		strParam += "," + this.report.NumCardsID + "|NumCards";

		//Parameter 3: STARTDATE
		strParam += "," + moment(this.report.STARTDATE).format("MM/DD/YYYY") + "|STARTDATE";

		//Parameter 4: ENDDATE
		strParam += "," + moment(this.report.ENDDATE).format("MM/DD/YYYY") + "|ENDDATE";

		//Parameter 5: ORDERBY
		strParam += "," + this.report.ORDERBYID + "|ORDERBY";

		//Parameter 6: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
